import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Склеивает классы и разрешает конфликты Tailwind.
 *
 * Без `twMerge` пара `"px-4"` + `"px-2"` даёт обе директивы, и победит та,
 * что стоит позже в сгенерированном CSS, — а не та, что передана последней.
 * Это ломает переопределение стилей через проп `className` у компонентов.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
